(function() { window.GUID_9efd6d72_81d4_4465_a4be_1993dded0b3b = { getGuid: function() { return "9efd6d72-81d4-4465-a4be-1993dded0b3b"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let PlayerSearchSorting;
        (function (PlayerSearchSorting) {
            PlayerSearchSorting[PlayerSearchSorting["Name"] = 0] = "Name";
            PlayerSearchSorting[PlayerSearchSorting["Rank"] = 1] = "Rank";
            PlayerSearchSorting[PlayerSearchSorting["CSR"] = 2] = "CSR";
        })(PlayerSearchSorting = Enumeration.PlayerSearchSorting || (Enumeration.PlayerSearchSorting = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PlayerSearchSorting.pre.js.map
